/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Icon, WingBlank } from "antd-mobile";
import { FormattedMessage } from "react-intl";
import "./index.css";

const StyledContainer = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: ${props => (props.mode === "outline" ? "#EEEEEE" : "white")};
  color: grey;
  border: 1px solid lightgrey;
  padding: 0.6em;
  height: 0.98em;
`;

const StyledPlaceholderContainer = styled.div`
  cursor: pointer;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

const StyledIcon = styled(Icon)`
  cursor: pointer;
  color: grey;
`;

class SearchBarButton extends Component {
  onClick = () => {
    const { history } = this.props;

    history && history.push("/shop/search");
  };

  render() {
    const { outline } = this.props;

    return (
      <StyledContainer mode={outline ? "outline" : "inline"}>
        <StyledPlaceholderContainer onClick={() => this.onClick()}>
          <StyledIcon type={"search"} size={"xs"} />
          <WingBlank size="sm" />
          <FormattedMessage
            id="component.searchbar.placeholder"
            defaultMessage="Search"
            description="Search placeholder at Search bar"
          />
        </StyledPlaceholderContainer>
      </StyledContainer>
    );
  }
}

SearchBarButton.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
  outline: PropTypes.bool
};

export default SearchBarButton;



// WEBPACK FOOTER //
// ./src/components/SearchBarButton/index.js